import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "calendar",
  "use": "calendar-usage",
  "viewBox": "0 0 20.2 23.7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20.2 23.7\" id=\"calendar\"><path d=\"M20.2 23.7H0v-20h4.8V0h1.1v3.7h8.3V0h1.1v3.7h4.9v20zM1.1 22.6h18V8.7h-18v13.9zm0-15h18V4.8h-18v2.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol